module.exports = __webpack_public_path__ + "media/mda-jkinmhhzqaaaqxt4.300de41b.mp4";